<template>
  <div ref="containerRef">
    <div
      class="relative z-20 flex items-center rounded-full bg-white px-2 transition-all duration-200"
    >
      <input
        v-model="query"
        :placeholder="$t('pages.header.search.placeholder')"
        class="h-11 w-full appearance-none border-0 bg-transparent p-2 text-base leading-normal text-black outline-none transition placeholder:text-gray-darkest focus:border-transparent focus:outline-none focus:ring-0"
        autocapitalize="none"
        autocomplete="off"
        autocorrect="off"
        maxlength="128"
        @focus="showAutocompleteBox = true"
      />
      <MagnifyingGlassIcon class="h-6 cursor-pointer pr-1" />
    </div>

    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div v-if="showAutocompleteBox" class="relative z-10 w-full">
        <div
          class="absolute z-10 -mt-6 w-full rounded-b-lg bg-white pt-6 shadow-md"
        >
          <AisIndex :index-name="productStore.productIndex">
            <AisConfigure
              :query="debouncedQuery"
              :hits-per-page.camel="
                categoryStore.numberOfProductAutocompleteResults
              "
            />
            <AisHits>
              <template #default="{ items, sendEvent }">
                <AutocompleteHit
                  v-for="item of items"
                  :key="item.objectID"
                  :item="item"
                  @on-item-click="() => sendEvent('click', item, 'Hit Clicked')"
                />
              </template>
            </AisHits>
          </AisIndex>
          <AisIndex :index-name="categoryStore.categoryIndex">
            <AisConfigure
              :query="debouncedQuery"
              :hits-per-page.camel="
                categoryStore.numberOfCategoryAutocompleteResults
              "
            />
            <AisHits>
              <template #default="{ items, sendEvent }">
                <AutocompleteHit
                  v-for="item of items"
                  :key="item.objectID"
                  :item="item"
                  @on-item-click="() => sendEvent('click', item, 'Hit Clicked')"
                />
              </template>
            </AisHits>
          </AisIndex>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import AutocompleteHit from '@/pages/HeaderPage/Partials/AutocompleteHit.vue';
import { useAlgoliaCategoryStore } from '@/stores/Category/AlgoliaCategoryStore.ts';
import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid';
import { onClickOutside, watchDebounced } from '@vueuse/core';
import { ref, useTemplateRef } from 'vue';
import { useAlgoliaProductStore } from '@/stores/Category/AlgoliaProductStore';

const showAutocompleteBox = ref(false);
const containerRef = useTemplateRef<HTMLDivElement>('containerRef');
const categoryStore = useAlgoliaCategoryStore();
const productStore = useAlgoliaProductStore();

onClickOutside(containerRef, () => (showAutocompleteBox.value = false));
const query = ref('');
const debouncedQuery = ref('');

watchDebounced(query, value => (debouncedQuery.value = value), {
  debounce: 150,
  immediate: true,
});
</script>
